import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiCallCachingService {
  
  private cachingDictionary: { [key: string]: ReplaySubject<any>; } = {};

  constructor() { }

  getValue<T>(key: string, apiCall: Observable<T>) {
    if (this.cachingDictionary[key]) {
      return this.cachingDictionary[key].asObservable() as Observable<T>;
    }
    //create new observable, else return already created observable, this ensures that the call is only made once
    
    if(apiCall){
      this.cachingDictionary[key] = new ReplaySubject<T>();
      apiCall.subscribe(x => {
        this.cachingDictionary[key].next(x);
        this.cachingDictionary[key].complete();
      });
     
      return this.cachingDictionary[key].asObservable() as Observable<T>;
    }
   
    return apiCall;
  }

  invalidate(keys: string[])
  {
    keys.forEach(key => {
      if(this.cachingDictionary[key]){
        delete this.cachingDictionary[key];
      }
    });
  }
}
